import { createApi } from '@reduxjs/toolkit/query/react';
import axiosBaseQuery from './baseQuery';

export interface INotificationBlock {
  type: 'paragraph' | 'image';
  text?: string;
  url?: string;
  alt?: string;
}

export interface INotificationResponse {
  notification_id: number;
  title: string;
  published_at: string;
  status: number;
  body: INotificationBlock[];
}

export interface INotificationPayload {
  title: string;
  published_at: string;
  status: number;
  body: INotificationBlock[];
}

export const notificationApi = createApi({
  reducerPath: 'notification_api',
  tagTypes: ['notifications'],
  baseQuery: axiosBaseQuery(),
  endpoints: build => ({
    getNotifications: build.query<INotificationResponse[], string | void>({
      query: params => ({
        url: `/notifications${params ? '?' + params : ''}`,
        method: 'GET',
      }),
      providesTags: ['notifications'],
      transformResponse: (result: { data: INotificationResponse[] }) =>
        result.data,
    }),
    createNotification: build.mutation<void, INotificationPayload>({
      query: body => ({
        url: '/notifications',
        method: 'POST',
        data: body,
      }),
      invalidatesTags: ['notifications'],
    }),
    updateNotification: build.mutation<
      void,
      { id: number; body: INotificationPayload }
    >({
      query: ({ id, body }) => ({
        url: `/notifications/${id}`,
        method: 'PUT',
        data: body,
      }),
      invalidatesTags: ['notifications'],
    }),
    deleteNotification: build.mutation<void, number>({
      query: id => ({
        url: `/notifications/${id}`,
        method: 'DELETE',
      }),
      invalidatesTags: ['notifications'],
    }),
  }),
});

export const {
  useGetNotificationsQuery,
  useCreateNotificationMutation,
  useUpdateNotificationMutation,
  useDeleteNotificationMutation,
} = notificationApi;
